const getDefaultState = () => ({
  bookingList: {
    bookings: {
      items: [],
      error: false,
      loading: false,
    },
    sendingMails: {
      error: false,
      loading: false,
    },
  },
  emailList: {
    bookings: {
      items: [],
      error: false,
      loading: false,
    },
  },
  domains: {
    items: [],
    error: false,
    loading: false,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/giftVoucher/defaultState.js